// Module
var code = "<div ng-if=\"$ctrl.isLowestPriceShown\" class=\"lowest-month-price\"> <span class=\"lowest-month-price__description\" system-dictionary=\"LowestPriceDescription\"/> <span class=\"lowest-month-price__value\"> {{ $ctrl.lowestMonthPriceFormatted }} </span> </div>";
// Exports
module.exports = code;